export default "__VITE_ASSET__BF3TyKLL__"